import GetMeRequestModelBase from '../_generated/modelBases/get-me-request-model-base';

export default class GetMeRequestModel extends GetMeRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
